<script lang="ts">
  import Form from "./Form.svelte";
  import Lock from "~icons/ph/lock";
  import { domId } from "../lib/dom";

  let {
    phoneIcon,
    action,
    clickedYesInteraction,
    clickedNoInteraction,
  }: {
    phoneIcon: string;
    action: string;
    clickedYesInteraction: string;
    clickedNoInteraction: string;
  } = $props();

  let checked = $state(false);

  const closeDialogId = domId("close-dialog");
  let buttonBehavior = $derived(checked ? {"data-interaction": clickedYesInteraction} : {"data-interaction": clickedNoInteraction, form: closeDialogId});
</script>

<Form method="post" {action}>
  <div class="flex flex-col gap-4 items-center text-center text-wrap bg-[radial-gradient(ellipse_300%_80%_at_top,_var(--tw-gradient-stops))] from-blue-500/40 to-40% -m-[--box-padding] p-[--box-padding] pt-6">
    <h2 class="text-2xl">🎉 Welcome to your JLG Portal!</h2>
    <img src={phoneIcon} class="h-48 -mb-4 pr-3" alt="Phone icon" />
    <div class="mb-2">Track your claim—look for the orange dot for updates and tasks to complete.</div>

    <div class="self-stretch flex items-center justify-between gap-2 bg-gray-100 p-2 rounded-lg text-sm font-medium">
      <div class="flex items-center gap-2">
        <input type="checkbox" class="checkbox bg-white [--chkbg:white] [--chkfg:black]" id="remember_me" bind:checked />
        <label for="remember_me" class="cursor-pointer">
          Stay logged in for 60 days
        </label>
      </div>
      <span class="text-emerald-700 bg-emerald-100 px-2 rounded-full">Recommended</span>
    </div>

    <button class="btn btn-primary self-stretch" {...buttonBehavior}>Continue</button>

    <div class="flex items-center gap-1 text-gray-500">
      <Lock style="bold" class="w-[17px] h-[17px]" />
      <p class="text-sm font-medium">Your data is encrypted and securely stored.</p>
    </div>
  </div>
</Form>
<form id={closeDialogId} method="dialog"></form>
